import { render, staticRenderFns } from "./ProductDesignFormInterliningEdit.vue?vue&type=template&id=45f2c1eb&"
import script from "./ProductDesignFormInterliningEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormInterliningEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports